export enum InfoWrapperTypes {
    PRIMARY = 'info-wrapper-primary',
    FAILURE = 'info-wrapper-failure',
    DANGER = 'info-wrapper-danger',
    SUCCESS = 'info-wrapper-success'
}